// extracted by mini-css-extract-plugin
module.exports = {"mainview":"mainview--3zmF_hWo8"};